class ArtajCommerceHeader extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-artaj-menu-toggle]');
    this.menu = this.querySelector('[data-artaj-mobile-menu]');
    this.scrollIndicator = this.querySelector('.artaj-design-language-scroll');

    if (this.toggle && this.menu) {
      this.toggle.addEventListener('click', this.handleToggle);
      this.addEventListener('keydown', this.handleKeydown);
      this.menu.addEventListener('click', this.handleMenuClick);
    }

    if (this.scrollIndicator) {
      this.updateScrollIndicator = this.updateScrollIndicator.bind(this);
      window.addEventListener('scroll', this.updateScrollIndicator, { passive: true });
      window.addEventListener('resize', this.updateScrollIndicator);
      this.updateScrollIndicator();
    }
  }
  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.handleToggle);
    this.removeEventListener('keydown', this.handleKeydown);
    this.menu?.removeEventListener('click', this.handleMenuClick);
    if (this.updateScrollIndicator) {
      window.removeEventListener('scroll', this.updateScrollIndicator);
      window.removeEventListener('resize', this.updateScrollIndicator);
    }
  }
  handleToggle = () => {
    const open = this.toggle.getAttribute('aria-expanded') !== 'true';
    this.toggle.setAttribute('aria-expanded', String(open));
    this.menu.hidden = !open;
  };
  handleKeydown = (event) => {
    if (event.key !== 'Escape' || this.menu.hidden) return;
    this.closeMenu();
    this.toggle.focus();
  };
  handleMenuClick = (event) => {
    if (event.target.closest('a')) this.closeMenu();
  };
  closeMenu() {
    this.toggle.setAttribute('aria-expanded', 'false');
    this.menu.hidden = true;
  }
  updateScrollIndicator() {
    const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollProgress = scrollableHeight > 0 ? window.scrollY / scrollableHeight : 0;
    const shouldHide = scrollProgress >= 0.2;

    this.scrollIndicator.classList.toggle('is-hidden', shouldHide);
    this.scrollIndicator.setAttribute('aria-hidden', String(shouldHide));
    this.scrollIndicator.tabIndex = shouldHide ? -1 : 0;
  }
}
if (!customElements.get('artaj-commerce-header')) customElements.define('artaj-commerce-header', ArtajCommerceHeader);
